export const BASE_URL = "https://nodeapp.sitsuvidya.in/nodeapp"
export const IMG_URL = "https://sitsuvidya.in/uploads"
// export const Festival_URL = "https://sitsuvidya.in/uploads"
// export const BASE_URL = "http://localhost:8081/nodeapp"
 
